import { string, object } from "prop-types"
import { v4 as uuidv4 } from "uuid"

export function showFirstNameWarning(firstName) {
  return /(\s\+|\||&|\sand\s|&amp;|\/|\\)/i.test(firstName)
}

export const SharedFirstNameWarning = ({
  firstName,
  className = "c-marigold mb-1",
  style = {},
  key = uuidv4(),
  warning = "For accuracy, use one name only."
}) => {
  return (
    showFirstNameWarning(firstName) && (
      <div key={key} className={className} style={style}>
        {warning}
      </div>
    )
  )
}

SharedFirstNameWarning.propTypes = {
  firstName: string.isRequired,
  className: string,
  style: object,
  key: string,
  warning: string
}
